module.exports = __webpack_public_path__ + "static/media/pon-metro-footer.b7fd4971.svg";